import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = { stepId: Number }

  connect() {
    this.#sortable = Sortable.create(this.element, {
      group:            "kanban",
      animation:        150,
      ghostClass:       "kanban-card--ghost",
      filter:           ".kanban-card__actions",
      preventOnFilter:  false,
      onStart:          this.#onStart.bind(this),
      onEnd:            this.#onEnd.bind(this)
    })
  }

  disconnect() {
    this.#sortable?.destroy()
  }

  #onStart({ from }) {
    this.#startOrder = this.#customerIds(from).join(",")
  }

  async #onEnd({ item, to, from }) {
    const currentOrder = this.#customerIds(to).join(",")
    if (to === from && currentOrder === this.#startOrder) return

    const customerId = item.dataset.customerId
    const stepId    = to.dataset.kanbanColumnStepIdValue
    const body      = new URLSearchParams({ "customer[funnel_step_id]": stepId })

    this.#customerIds(to).forEach(id => body.append("customer[ordered_customer_ids][]", id))

    if (from !== to) {
      this.#customerIds(from).forEach(id => body.append("customer[source_customer_ids][]", id))
    }

    const response = await fetch(`/funnel/customers/${customerId}`, {
      method:  "PATCH",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Content-Type": "application/x-www-form-urlencoded",
        "Accept":       "text/vnd.turbo-stream.html"
      },
      body
    })

    if (response.ok) {
      Turbo.renderStreamMessage(await response.text())
    } else {
      // Server rejected the move — restore the page to the real state
      Turbo.visit(window.location.href)
    }
  }

  #customerIds(list) {
    return [...list.querySelectorAll("[data-customer-id]")].map(card => card.dataset.customerId)
  }

  #sortable = null
  #startOrder = null
}
